<template>
  <div>
    <ejs-grid ref="listNe" :dataSource='data'>
      <e-columns>
        <e-column field='text' :headerText='$t("Software.td_neID")' width='15%' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>
<script>

  export default {
    name: "TemplateDownloadDialog",
    data() {
      return {
        data: []
      }
    },
    methods: {
      getGMSList(){
        const $this = this;
        this.$axios.post('/lte/ems/auth/findElementListByAuth', [2142]).then((response) => {
          const _nodeArray = response.data;
          const showData = [];
          _nodeArray.forEach((_item) => {
            const {physicalIP, id, name} = _item;
            const _dataItem = {
              text: `${physicalIP} — ${id} — ${name}`,
              id
            };
            showData.push(_dataItem);
          })
          $this.data = showData;
        })
      }
    }
  }
</script>
